import axiosInstance from './api';

export const getAllCommandes = () => axiosInstance.get('/commande');

export const getCommandeByReference = (reference) =>
  axiosInstance.get(`/commande/reference/${reference}`);

export const confirmCommande = (id) =>
  axiosInstance.patch(`/commande/${id}/confirm`);

export const cancelCommande = (id) =>
  axiosInstance.patch(`/commande/${id}/cancel`);
